module.exports = __webpack_public_path__ + "static/hollyfrontier-logo-924efed421666dd6e7f1f68edf9330a3.png";